import React, { useState, useEffect } from "react";
import { generateContestOtp } from "../../ApiServices/ApiServices";
import { handleError } from "../../Utils";

const Volunteers = ({ passKey }) => {
  const [otpGeneratedAt, setOtpGeneratedAt] = useState(null);
  const [timeLeft, setTimeLeft] = useState(0);
  const [otp, setOtp] = useState("");

  useEffect(() => {
    let timer;
    if (otpGeneratedAt) {
      timer = setInterval(() => {
        const elapsed = Math.floor((Date.now() - otpGeneratedAt) / 1000);
        const remaining = Math.max(300 - elapsed, 0);
        setTimeLeft(remaining);

        if (remaining === 0) {
          clearInterval(timer);
          setOtpGeneratedAt(null);
        }
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [otpGeneratedAt]);

  const handleGenerateOtp = async () => {
    try {
      if (!otpGeneratedAt) {
        const otp = await generateContestOtp(passKey);
        setOtp(otp?.otp);
        setOtpGeneratedAt(Date.now());
      }
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }
  };

  const formatTime = (seconds) => {
    const m = String(Math.floor(seconds / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");
    return `${m}:${s}`;
  };

  return (
    <div className="max-w-[300px] mx-auto  p-8 rounded-[12px] shadow-[0_4px_20px_rgba(0,0,0,0.1)] font-['Segoe_UI',sans-serif] bg-white">
      <h2 className="text-center mb-8 text-[#333] text-2xl">
        Volunteers Authentication
      </h2>

      <div className="mb-6">
        <label className="block mb-2 text-[#555] text-[17px]">Passkey:</label>
        <input
          type="text"
          disabled
          value={passKey}
          placeholder="Passkey"
          className="w-full p-[10px] font-bold rounded-[8px] border border-[#ccc] bg-[#f9f9f9] text-sm"
        />
      </div>

      <div className="mb-6">
        <label className="block mb-2 text-[#555] text-[17px]">OTP:</label>
        <input
          type="text"
          disabled
          placeholder="OTP"
          value={otp}
          className="w-full font-bold p-[10px] rounded-[8px] border border-[#ccc] bg-[#f9f9f9] text-sm"
        />
      </div>

      <button
        onClick={handleGenerateOtp}
        disabled={otpGeneratedAt !== null}
        className={`w-full py-[12px] text-white text-[16px] rounded-[8px] border-none transition-colors duration-300 ${
          otpGeneratedAt
            ? "bg-[#ccc] cursor-not-allowed"
            : "bg-[#4ade80] cursor-pointer"
        }`}
      >
        Generate OTP
      </button>

      {otpGeneratedAt && (
        <p className="mt-6 text-center text-sm text-[#888]">
          Time left to regenerate: <strong>{formatTime(timeLeft)}</strong>
        </p>
      )}
    </div>
  );
};

export default Volunteers;
